<form [formGroup]="MobileNumberSubmitForm">
  <label for="">
    <div class="row collapse">
      <div class="rs-form-item">
        <input
          type="text"
          formControlName="mobileNumber"
          name="mobileNumber"
          id="mobileNumber"
          autocomplete="off"
          class="rs-input-collapsed"
          data-cy="addMobileNumber"
          maxlength="10"
          aria-describedby="ac-helper-number03"
          [ngClass]="{ 'rs-filled': !isNumberEmpty() }"
        /><label for="mobileNumber" class="rs-form-label">{{
          'password.recovery.method.sms.input.placeholder' | translate
        }}</label>
        <div class="rs-form-helper" id="ac-helper-number03">
          {{ 'password.recovery.method.sms.input.number.format' | translate }}
        </div>
      </div>

      <mprd-mobile-number-errors
        [errors]="MobileNumberSubmitForm.get('mobileNumber').errors"
        *ngIf="isMobileNumberSubmitFormHasErrors"
      ></mprd-mobile-number-errors>

      <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
        <div class="rs-flex-column rs-order-m3">
          <button
            class="rs-btn"
            data-cy="recoveryphoneSubmitButton"
            (click)="onValidMobileNumberSubmit()"
            [disabled]="!MobileNumberSubmitForm.valid || showLoadingSpinner"
            [pxAnalyticsElementClicked]="{
              event_detail: 'Change recovery phone nbr',
              event_location: 'myWebMail',
              event_action: 'click'
            }"
          >
            {{ 'password.recovery.method.sms.submit.button' | translate }}
          </button>
        </div>
        <div class="rs-flex-column rs-flex-shrink rs-order-m1">
          <p class="text-center">
            <a href="javascript:void(0)" (click)="onMobileNumberSubmitCancel()">{{
              'password.recovery.method.sms.cancel.button' | translate
            }}</a>
          </p>
        </div>
      </div>
    </div>
  </label>
</form>
